import React from "react";
import { SectionHeader } from "../../../components/ui/section";
import { cn } from "../../../lib/utils";
import { CONTRACTOR_SURFACE_RADIUS_MD_CLASS } from "../layoutRadius";
import type { Faq } from "../types";

type FaqSectionProps = {
  faqs: Faq[];
};

export const FaqSection: React.FC<FaqSectionProps> = ({ faqs }) =>
  faqs.length > 0 ? (
    <section className="bg-muted/40 py-16">
      <div className="mx-auto max-w-5xl px-6">
        <SectionHeader
          center
          className="mb-8"
          kicker="FAQs"
          title="Frequently asked questions"
          description="Quick answers before you book."
        />
        <ul className="space-y-4">
          {faqs.map((faq) => (
            <li key={faq.question}>
              <div
                className={cn(
                  "border border-border bg-card p-6 text-card-foreground shadow-sm",
                  CONTRACTOR_SURFACE_RADIUS_MD_CLASS,
                )}
              >
                <h3 className="mb-2 font-display text-lg font-semibold text-foreground">
                  {faq.question}
                </h3>
                <p className="text-sm leading-relaxed text-muted-foreground">
                  {faq.answer}
                </p>
              </div>
            </li>
          ))}
        </ul>
      </div>
    </section>
  ) : null;
